import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import rootReducerConfig from '../reducers';
import initialState from './initialState';
import middleware from '../middleware';

const enhancers = [];

if (typeof window !== 'undefined' && typeof window.__REDUX_DEVTOOLS_EXTENSION__ === 'function')
  enhancers.push(
    window.__REDUX_DEVTOOLS_EXTENSION__({ serialize: true, trace: true })
  );

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
);

const createReducerFromConfig = ({ name, reducers }) => {
  return (state = initialState[name], action) =>
    !reducers[action.type]
      ? state
      : reducers[action.type]({ ...state }, action);
};

const buildRootReducer = config => {
  const map = {};
  config.forEach(cfg => (map[cfg.name] = createReducerFromConfig(cfg)));

  // Keep any initialState keys that have no reducer from crashing
  Object.keys(initialState)
    .filter(key => !map[key])
    .forEach(key => (map[key] = (state = null) => state));

  return combineReducers(map);
};

const store = createStore(
  buildRootReducer(rootReducerConfig),
  initialState,
  composedEnhancers
);

export default store;
